import { CodeItem } from './../../../common/interfaces/code-item.interface';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'prg-code-item-icons',
  templateUrl: './code-item-icons.component.html',
  styleUrls: ['./code-item-icons.component.less']
})
export class CodeItemIconsComponent implements OnInit {

  @Input() codeItem: CodeItem;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-common/code-item-icons/code-item-icons.component.ts